import React from 'react';
import {authRoles} from 'app/auth';

export const AdminAppConfig = {
    settings: {
        layout: {}
    },
    auth    : authRoles.admin,
    routes  : [
        {
            path     : '/settings/admin/importer',
            component: React.lazy(() => import('./importer/Importer'))
        },
        {
            path     : '/settings/admin/snapshots',
            component: React.lazy(() => import('./snapshots/Snapshots'))
        },
        {
            path     : '/settings/admin/thresholds',
            component: React.lazy(() => import('./settings/Settings'))
        },
        {
            path     : '/settings/admin/reports',
            component: React.lazy(() => import('./reports/ReportSettings'))
        },

        // {
        //     path     : '/settings/admin/manager',
        //     component: React.lazy(() => import('./manager/Manager'))
        // },
        {
            path     : '/settings/admin',
            component: React.lazy(() => import('./AdminApp'))
        }
    ]
};
